import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';


import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { CookiesProvider, withCookies } from 'react-cookie';


const GET_USERS = gql`
  query WebsiteNotifications {
    websiteNotifications{
      id
      title
      text
      img_url
      active
      link
    }
  }
`;

@autobind
class NotificationCenter extends React.Component {
  state = {
    onLocalHost: false,
    display:false,
    visibility:false,
  };

   

  hide(e, id){
    e.preventDefault()
    this.setState({visibility:false});
    setTimeout(() => this.setState({ display: false}), 200);

    var now=new Date();
    now.setDate(now.getDate()+8)

    const { cookies } = this.props;
    cookies.set('notif'+id, "yes", { path: '/', expires: now});
  }

  componentDidMount(){
    if(document.cookie.replace(/(?:(?:^|.*;\s*)notif\s*\s*([^;]*).*$)|^.*$/, "$1") !== "=yes"){
      setTimeout(() => this.setState({ display:true}), 1200);
      setTimeout(() => this.setState({ visibility: true}), 2200);
    }
  }


  render() {
    const marginTop = this.state.visibility ? styles.marginTopNo : styles.marginTopYes;

    const { cookies } = this.props;
    

    return (
      <CookiesProvider>
      <div className={css(styles.wrapperMain, marginTop)}>
        <Query query={GET_USERS}>
          {({ loading, error, data }) => {
            if (loading){
              return(
                "loading"
              )
            };
            if (error) return `Error! ${error.message}`;
            
            if(data.websiteNotifications){
              return(
                data.websiteNotifications.map((notification, index)=>{
                  if(notification.active){
                    if(notification.link){
                      return(
                        <a rel="noopener noreferrer" target="_blank" href={notification.link} key={notification.id} className={cookies.get("notif"+notification.id) !== "yes" ? css(styles.wrapper, styles.transitionSecond) : css(styles.wrapper, styles.transitionFirst)}>
                          <div className={css(styles.imgWrapper)}>
                            <img alt={notification.img_url} className={css(styles.img)} src={notification.img_url} />
                          </div>
                          <div className={css(styles.textWrapper)}>
                            <div className={css(styles.title)}>{notification.title}</div>
                            <p className={css(styles.text)}>{notification.text}</p>
                          </div>
                          <img alt="close" onClick={(e)=>this.hide(e, notification.id)} className={css(styles.close)} src="../assets/icons/close.png" />
                        </a>
                      )
                    } else {
                      return(
                        <div key={notification.id} className={cookies.get("notif"+notification.id) !== "yes" ? css(styles.wrapper, styles.transitionSecond) : css(styles.wrapper, styles.transitionFirst)}>
                          <div className={css(styles.imgWrapper)}>
                            <img alt={notification.img_url} className={css(styles.img)} src={notification.img_url} />
                          </div>
                          <div className={css(styles.textWrapper)}>
                            <div className={css(styles.title)}>{notification.title}</div>
                            <p className={css(styles.text)}>{notification.text}</p>
                          </div>
                          <img alt="close" onClick={(e)=>this.hide(e, notification.id)} className={css(styles.close)} src="../assets/icons/close.png" />
                        </div>
                      )
                    }
                  } else {
                    return null
                  }
                })
                
              )
            } else {
              return null
            }
          }}
        </Query>
      </div>
      </CookiesProvider>
    );
  }
}

const styles = StyleSheet.create({
  wrapperMain:{
    position:"fixed",
    left:15,
    zIndex:10,
    bottom:0,
    
    '@media (max-width: 560px)': {
      position:"relative",
      width:"100%",
      left:0,
      // display:"flex",
      bottom:0,
    },
    '@media (max-width: 400px)': {
      width:"100%",
      maxWidth:380,
    },
    '@media (max-width: 340px)': {
      left:0,
    }
  },
  marginTopYes:{
   
  },
  marginTopNo:{
   
  },
  wrapper:{
    textDecoration:"none",
    maxWidth:370,
    width:"100%",
    position:"relative",
    boxShadow: "0px 2px 24px rgba(21, 23, 54, 0.15)",
    zIndex:"10000",
    color:"#000",
    display:"flex",
    alignItems:"center",
    background:"#fff",
    height:90,
    transition:"0.5s",
    '@media (max-width: 500px)': { 
      maxWidth:380,
      width:"100%",
    },
    '@media (max-width: 400px)': { 
      width:"100%",
    },
  },
  title:{
    fontSize:12,
    marginBottom:4,
    fontWeight:500,
    lineHeight: "18px",
    textDecoration:"none",
  },
  displayON:{
    opacity:1,
  },
  displayOFF:{
    opacity:0,
  },
  transitionFirst:{
    bottom:-10,
    opacity:0,
    marginBottom:0,
    height:0,
    transition:"0.2s",
    overflow:"hidden",
  },
  transitionSecond:{
    marginBottom:15,
    transition:"0.2s",
    '@media (max-width: 560px)': {
      marginBottom:0,
      marginTop:10,
    },
    opacity:1,
  },
  imgWrapper:{
    display:"flex",
    justifyContent:"center",
    height:60,
    width:60,
    borderRadius:"0%",
    overflow:"hidden",
    alignItems:"center",
    background:"#FBFBFB",
    marginRight:22,
    marginLeft:16,
  },
  img:{
    height:"100%",
    width:"100%",
    objectPosition:"0% 0%",
    objectFit:"cover",
  },
  textWrapper:{
    marginRight:20,
    lineHeight:1.3,
    textDecoration:"none",
  },
  text:{
    color:"#A3A3A3",
    fontSize:12,
    maxWidth:190,
    textDecoration:"none",
    lineHeight:"18px",
    letterSpacing: "0.136364px",
    marginTop:0,
    marginBottom:0,
  },
  close:{
    position:"absolute",
    width:18,
    top:8,
    right:8,
    opacity:1,
    zIndex:10,
    transition: "all .2s",
    cursor:"pointer",
    ":hover":{
      opacity:0.7,
    }
  },
  
});

export default withCookies(NotificationCenter);
